"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCouponDiscountLabel = exports.default = exports.APPLY_COUPON_PAGE_DEFAULTS = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _reactLottie = _interopRequireDefault(require("react-lottie"));
var _CouponTicketCard = _interopRequireDefault(require("../CouponTicketCard/CouponTicketCard"));
var _couponOffer = require("../../utils/couponOffer");
var _noCoupons = _interopRequireDefault(require("./animations/no-coupons.json"));
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["open", "onClose", "coupons", "appliedCouponCode", "onApply", "onRemove", "mapCoupon", "closeOnApply", "allowManualCode", "verifyManualCode", "error", "invalidCodeText", "title", "sectionTitle", "inputPlaceholder", "applyText", "emptyText", "emptyAnimation", "emptyAnimationSize", "emptyAnimationLoop", "emptyBackground", "fontFamily", "colors", "cardProps", "sx"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const APPLY_COUPON_PAGE_DEFAULTS = exports.APPLY_COUPON_PAGE_DEFAULTS = {
  title: 'Apply Coupon',
  sectionTitle: 'Available Coupons',
  inputPlaceholder: 'Enter coupon code',
  applyText: 'APPLY',
  emptyText: 'No coupons available for you!',
  invalidCodeText: 'This coupon code is invalid',
  fontFamily: 'Inter, sans-serif',
  emptyBackground: 'linear-gradient(to bottom, #ffffff 16.733%, #ede8ff 103.49%)',
  emptyAnimation: _noCoupons.default,
  emptyAnimationSize: 200,
  colors: {
    background: '#fafafa',
    header: '#ffffff',
    title: '#222226',
    sectionTitle: '#0f0b28',
    field: '#ffffff',
    fieldBorder: '#e5e4e7',
    placeholder: '#b1afb6',
    inputText: '#222226',
    brand: 'var(--primary-button, #714fff)',
    error: '#ef4444',
    muted: '#686670'
  }
};
const SlideUp = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Slide, _objectSpread({
  direction: "up",
  ref: ref
}, props)));
const BackIcon = _ref => {
  let _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#000000' : _ref$color;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-hidden": "true",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M15 19L8 12L15 5",
      stroke: color,
      strokeWidth: "1.7",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
const getCouponDiscountLabel = function () {
  let coupon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (coupon.discountLabel) return coupon.discountLabel;
  if (coupon.offLabel) return coupon.offLabel;
  const amount = (0, _couponOffer.getCouponOffAmount)(coupon);
  return amount ? "".concat(amount, " OFF") : 'OFFER';
};

// A handler can reject an apply outright — by throwing, returning false, or
// resolving to something carrying success: false / an error message.
exports.getCouponDiscountLabel = getCouponDiscountLabel;
const readFailure = result => {
  if (result === false) return {};
  if (result && typeof result === 'object') {
    const message = result.errorMessage || result.couponMessage || result.message;
    if (result.success === false || result.error) return {
      message
    };
  }
  return null;
};
const errorText = err => {
  var _err$response, _err$response2;
  return (err === null || err === void 0 || (_err$response = err.response) === null || _err$response === void 0 || (_err$response = _err$response.data) === null || _err$response === void 0 ? void 0 : _err$response.message) || (err === null || err === void 0 || (_err$response2 = err.response) === null || _err$response2 === void 0 || (_err$response2 = _err$response2.data) === null || _err$response2 === void 0 ? void 0 : _err$response2.errorMessage) || null;
};
const defaultMapCoupon = function () {
  let coupon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    code: coupon.couponCode,
    discountLabel: getCouponDiscountLabel(coupon),
    description: coupon.couponDescription,
    details: coupon.couponSubDescription
  };
};

/**
 * Full-screen "Apply Coupon" page. Only one coupon can be applied at a time —
 * applying a second one swaps it for the first, and every action is blocked
 * while a request is in flight.
 *
 * onApply/onRemove are called as (code, { manual }) — `manual` is true for a
 * code typed into the input, false for one picked from the list.
 */
const ApplyCouponPage = _ref2 => {
  var _ref3, _coupons$find;
  let _ref2$open = _ref2.open,
    open = _ref2$open === void 0 ? false : _ref2$open,
    onClose = _ref2.onClose,
    _ref2$coupons = _ref2.coupons,
    coupons = _ref2$coupons === void 0 ? [] : _ref2$coupons,
    appliedCouponCode = _ref2.appliedCouponCode,
    onApply = _ref2.onApply,
    onRemove = _ref2.onRemove,
    _ref2$mapCoupon = _ref2.mapCoupon,
    mapCoupon = _ref2$mapCoupon === void 0 ? defaultMapCoupon : _ref2$mapCoupon,
    _ref2$closeOnApply = _ref2.closeOnApply,
    closeOnApply = _ref2$closeOnApply === void 0 ? true : _ref2$closeOnApply,
    _ref2$allowManualCode = _ref2.allowManualCode,
    allowManualCode = _ref2$allowManualCode === void 0 ? true : _ref2$allowManualCode,
    _ref2$verifyManualCod = _ref2.verifyManualCode,
    verifyManualCode = _ref2$verifyManualCod === void 0 ? true : _ref2$verifyManualCod,
    error = _ref2.error,
    _ref2$invalidCodeText = _ref2.invalidCodeText,
    invalidCodeText = _ref2$invalidCodeText === void 0 ? APPLY_COUPON_PAGE_DEFAULTS.invalidCodeText : _ref2$invalidCodeText,
    _ref2$title = _ref2.title,
    title = _ref2$title === void 0 ? APPLY_COUPON_PAGE_DEFAULTS.title : _ref2$title,
    _ref2$sectionTitle = _ref2.sectionTitle,
    sectionTitle = _ref2$sectionTitle === void 0 ? APPLY_COUPON_PAGE_DEFAULTS.sectionTitle : _ref2$sectionTitle,
    _ref2$inputPlaceholde = _ref2.inputPlaceholder,
    inputPlaceholder = _ref2$inputPlaceholde === void 0 ? APPLY_COUPON_PAGE_DEFAULTS.inputPlaceholder : _ref2$inputPlaceholde,
    _ref2$applyText = _ref2.applyText,
    applyText = _ref2$applyText === void 0 ? APPLY_COUPON_PAGE_DEFAULTS.applyText : _ref2$applyText,
    _ref2$emptyText = _ref2.emptyText,
    emptyText = _ref2$emptyText === void 0 ? APPLY_COUPON_PAGE_DEFAULTS.emptyText : _ref2$emptyText,
    _ref2$emptyAnimation = _ref2.emptyAnimation,
    emptyAnimation = _ref2$emptyAnimation === void 0 ? APPLY_COUPON_PAGE_DEFAULTS.emptyAnimation : _ref2$emptyAnimation,
    _ref2$emptyAnimationS = _ref2.emptyAnimationSize,
    emptyAnimationSize = _ref2$emptyAnimationS === void 0 ? APPLY_COUPON_PAGE_DEFAULTS.emptyAnimationSize : _ref2$emptyAnimationS,
    _ref2$emptyAnimationL = _ref2.emptyAnimationLoop,
    emptyAnimationLoop = _ref2$emptyAnimationL === void 0 ? true : _ref2$emptyAnimationL,
    _ref2$emptyBackground = _ref2.emptyBackground,
    emptyBackground = _ref2$emptyBackground === void 0 ? APPLY_COUPON_PAGE_DEFAULTS.emptyBackground : _ref2$emptyBackground,
    _ref2$fontFamily = _ref2.fontFamily,
    fontFamily = _ref2$fontFamily === void 0 ? APPLY_COUPON_PAGE_DEFAULTS.fontFamily : _ref2$fontFamily,
    colorsProp = _ref2.colors,
    _ref2$cardProps = _ref2.cardProps,
    cardProps = _ref2$cardProps === void 0 ? {} : _ref2$cardProps,
    _ref2$sx = _ref2.sx,
    sx = _ref2$sx === void 0 ? {} : _ref2$sx,
    rest = _objectWithoutProperties(_ref2, _excluded);
  const colors = _objectSpread(_objectSpread({}, APPLY_COUPON_PAGE_DEFAULTS.colors), colorsProp);
  const _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    pendingCode = _useState2[0],
    setPendingCode = _useState2[1];
  const _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    codeInput = _useState4[0],
    setCodeInput = _useState4[1];
  const _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    failure = _useState6[0],
    setFailure = _useState6[1];
  const unverifiedRef = (0, _react.useRef)(null);
  const appliedCode = (_ref3 = appliedCouponCode !== null && appliedCouponCode !== void 0 ? appliedCouponCode : (_coupons$find = coupons.find(coupon => coupon === null || coupon === void 0 ? void 0 : coupon.isApplied)) === null || _coupons$find === void 0 ? void 0 : _coupons$find.couponCode) !== null && _ref3 !== void 0 ? _ref3 : null;
  const busy = pendingCode !== null;
  const finishApply = () => {
    setCodeInput('');
    if (closeOnApply) onClose === null || onClose === void 0 || onClose();
  };
  const runAction = async function (code, isApply) {
    let manual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    const handler = isApply ? onApply : onRemove;
    if (busy || !code || !handler) return;
    setFailure(null);
    setPendingCode(code);
    try {
      const rejected = readFailure(await handler(code, {
        manual
      }));
      if (rejected) {
        setFailure(rejected.message || invalidCodeText);
        return;
      }
      if (!isApply) return;
      // The handlers here refetch rather than report validity, so a typed code
      // is only trusted once it comes back applied.
      if (manual && verifyManualCode) unverifiedRef.current = code;else finishApply();
    } catch (err) {
      setFailure(errorText(err) || invalidCodeText);
    } finally {
      setPendingCode(null);
    }
  };

  // Don't carry a stale code or error into the next time the page opens.
  (0, _react.useEffect)(() => {
    if (open) return;
    unverifiedRef.current = null;
    setFailure(null);
    setCodeInput('');
  }, [open]);
  (0, _react.useEffect)(() => {
    const submitted = unverifiedRef.current;
    if (!submitted || busy) return;
    unverifiedRef.current = null;
    if (appliedCode === submitted) finishApply();else setFailure(invalidCodeText);
    // finishApply/invalidCodeText are stable enough for this one-shot check
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appliedCode, busy]);
  const typedCode = codeInput.trim().toUpperCase();
  const shownError = error !== null && error !== void 0 ? error : failure;
  const isEmpty = coupons.length === 0;
  const pageBackground = isEmpty ? emptyBackground : colors.background;
  const handleCodeChange = e => {
    setCodeInput(e.target.value);
    if (failure) setFailure(null);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Dialog, _objectSpread(_objectSpread({
    fullScreen: true,
    open: open,
    onClose: onClose,
    TransitionComponent: SlideUp,
    PaperProps: {
      sx: {
        background: pageBackground
      }
    }
  }, rest), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
      sx: _objectSpread({
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        background: pageBackground,
        fontFamily
      }, sx),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
        sx: {
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          px: '20px',
          py: '8px',
          background: colors.header,
          position: 'sticky',
          top: 0,
          zIndex: 1
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.ButtonBase, {
          disableRipple: true,
          onClick: onClose,
          "aria-label": "Go back",
          sx: {
            px: '4px',
            py: '8px'
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(BackIcon, {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
          sx: {
            flex: '1 0 0',
            minWidth: 0,
            fontFamily,
            fontWeight: 600,
            fontSize: '16px',
            lineHeight: 1.3,
            letterSpacing: '-0.12px',
            color: colors.title,
            m: 0
          },
          children: title
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
        sx: {
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: '24px',
          px: '20px',
          py: '16px',
          pb: '32px',
          boxSizing: 'border-box'
        },
        children: [allowManualCode && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
          sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
            sx: {
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              p: '12px',
              borderRadius: '12px',
              border: "1px solid ".concat(colors.fieldBorder),
              background: colors.field,
              boxShadow: '0px 0px 0px 1px #fafafa, 0px 0px 2px 0px rgba(0, 0, 0, 0.06)'
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.InputBase, {
              value: codeInput,
              onChange: handleCodeChange,
              placeholder: inputPlaceholder,
              inputProps: {
                'aria-label': inputPlaceholder
              },
              sx: {
                flex: '1 0 0',
                minWidth: 0,
                fontFamily,
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: 1.4,
                letterSpacing: '-0.12px',
                color: colors.inputText,
                '& input': {
                  p: 0,
                  textTransform: 'uppercase'
                },
                '& input::placeholder': {
                  color: colors.placeholder,
                  opacity: 1,
                  textTransform: 'none'
                }
              }
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.ButtonBase, {
              disableRipple: true,
              disabled: busy || !typedCode,
              onClick: () => runAction(typedCode, true, true),
              sx: {
                flexShrink: 0,
                opacity: typedCode ? 1 : 0.4
              },
              children: pendingCode && pendingCode === typedCode ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.CircularProgress, {
                size: 14,
                sx: {
                  color: colors.brand
                }
              }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
                sx: {
                  fontFamily,
                  fontWeight: 600,
                  fontSize: '12px',
                  lineHeight: 1.6,
                  color: colors.brand,
                  whiteSpace: 'nowrap',
                  m: 0
                },
                children: applyText
              })
            })]
          }), shownError && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
            role: "alert",
            sx: {
              fontFamily,
              fontWeight: 500,
              fontSize: '11px',
              lineHeight: 1.5,
              letterSpacing: '-0.12px',
              color: colors.error,
              m: 0
            },
            children: shownError
          })]
        }), isEmpty ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
          sx: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '24px',
            // sits above the optical centre, as in the design
            pb: '120px'
          },
          children: [emptyAnimation && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
            "aria-hidden": true,
            sx: {
              flexShrink: 0,
              width: "".concat(emptyAnimationSize, "px"),
              height: "".concat(emptyAnimationSize, "px"),
              pointerEvents: 'none'
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactLottie.default, {
              options: {
                loop: emptyAnimationLoop,
                autoplay: true,
                animationData: emptyAnimation,
                rendererSettings: {
                  preserveAspectRatio: 'xMidYMid meet'
                }
              },
              height: emptyAnimationSize,
              width: emptyAnimationSize,
              isClickToPauseDisabled: true,
              ariaRole: "presentation",
              ariaLabel: ""
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
            sx: {
              width: '100%',
              fontFamily,
              fontWeight: 500,
              fontSize: '18px',
              lineHeight: 1.4,
              letterSpacing: '-0.12px',
              textAlign: 'center',
              color: colors.muted,
              m: 0
            },
            children: emptyText
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
          sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: '20px'
          },
          children: [sectionTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
            sx: {
              fontFamily,
              fontWeight: 600,
              fontSize: '14px',
              lineHeight: 1.4,
              letterSpacing: '0.25px',
              color: colors.sectionTitle,
              m: 0
            },
            children: sectionTitle
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
            sx: {
              display: 'flex',
              flexDirection: 'column',
              gap: '16px'
            },
            children: coupons.map((coupon, index) => {
              var _card$code;
              const card = mapCoupon(coupon, index);
              const applied = !!card.code && card.code === appliedCode;
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CouponTicketCard.default, _objectSpread(_objectSpread({}, card), {}, {
                applied: applied,
                loading: pendingCode === card.code,
                disabled: busy && pendingCode !== card.code,
                onApply: code => runAction(code, true),
                onRemove: code => runAction(code, false)
              }, cardProps), (_card$code = card.code) !== null && _card$code !== void 0 ? _card$code : index);
            })
          })]
        })]
      })]
    })
  }));
};
var _default = exports.default = ApplyCouponPage;